import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemperatureSnowflake = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "temperature-snowflake" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12,
			y1: .75,
			x2: 12,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "15.75 2.25 12 5.25 8.25 2.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 2.257,
			y1: 6.375,
			x2: 8.752,
			y2: 10.125
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "5.431 3.877 6.154 8.625 1.681 10.373"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 2.257,
			y1: 17.625,
			x2: 8.752,
			y2: 13.875
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "1.681 13.627 6.154 15.375 5.431 20.123"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12,
			y1: 23.25,
			x2: 12,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "8.25 21.75 12 18.75 15.75 21.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.743,
			y1: 17.625,
			x2: 15.248,
			y2: 13.875
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "18.569 20.123 17.846 15.375 22.319 13.627"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.743,
			y1: 6.375,
			x2: 15.248,
			y2: 10.125
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "22.319 10.373 17.846 8.625 18.569 3.877"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "12 8.25 8.752 10.125 8.752 13.875 12 15.75 15.248 13.875 15.248 10.125 12 8.25"
		})
	]
});
export default SvgTemperatureSnowflake;
